import { Injectable } from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

    private urlPrefix = '/api/feature';

    constructor(private backend: BackendService) {}

    getFeaturePrimaryListByPropertyId(property:any): Observable<any> {
        const url = `${this.urlPrefix}/primary/property/${property}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getValueSecondaryListByPropertyId(property:any): Observable<any> {
        const url = `${this.urlPrefix}/secondary/property/${property}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getMultimediaPropertyList(propertyId:any): Observable<any> {
        const url = `${this.urlPrefix}/multimedia/property/${propertyId}?withFiles=true`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getFeaturePrimaryListBySegmentId(segmentId:any): Observable<any> {
        const url = `${this.urlPrefix}/primary/segment/${segmentId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    getValueSecondaryListBySegmentId(segmentId:any): Observable<any> {
        const url = `${this.urlPrefix}/secondary/segment/${segmentId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
}
